import { T_DefaultTrackMetadata } from "@type/global.types";
import dayjs from 'dayjs';
import { Frontend } from "shared-types";

export const defaultSelect = {
    number: {
        value: -1,
        label: ""
    },
    string: {
        value: "",
        label: ""
    }
}

export const defaultTrackMetadata: T_DefaultTrackMetadata = {
    trackTitle: "",
    explicitContent: 0,
    catalogue_num: "",
    distributionTerr: [],
    IsdistributionTerrSelected: "",
    lyrics: "",
    trackPart: "",
    instPossibleVal: 0,
    publisher_id: 0,
    circleP: "",
    startOfPreview: 0,
    yearOfPublication: dayjs(),
    priceCode: "",
    isrc: "",
    releaseDate: dayjs(),
    performers: [],
    trackFile: undefined,
    trackFileName: "",
    tempTrackInfo: {
        id: -1,
        user_id: -1
    },
    version: "",
    register_from: 2,
    rec_city: "",
    copyright_c: "",
    copyright_p: "",
    rec_date: dayjs(),
    rec_country_id: undefined,
    source_cd: "",
    source: "",
    licensor: ""
}

export const defaultTrackPostData: Frontend.T_TrackMetadataOutput = {
    catalogue_num: "",
    circle_p: "",
    isrc: "",
    lyrics: "",
    members: [],
    price_code: 0,
    publication_date: "",
    publisher_id: 0,
    register_from: 2,
    release_date: "",
    start_of_preview: 0,
    temp_track_info: "",
    track_file_name: "",
    track_part: "",
    track_title: "",
    track_type: "",
    update_performers: true,
    version: "",
    // licensor_id: 0,
    // publisher_id: 0
}